module.exports = __webpack_public_path__ + "img/bg6.69e3ba00.png";